import { Helmet } from "react-helmet-async";

const PageTitle = ({ children }: { children: string }) => {
  return (
    <Helmet>
      <title>{children} | Ecodrop Quotations Back-Office</title>
    </Helmet>
  );
};
export default PageTitle;